(function () {
  const nav = document.getElementById("mewNav");
  if (!nav) return;

  const toggleBtn = document.getElementById("mewNavToggle");
  const closeBtn  = document.getElementById("mewNavClose");
  const drawer    = document.getElementById("mewNavDrawer");
  const backdrop  = document.getElementById("mewNavBackdrop");
  const navLinks  = nav.querySelectorAll("[data-mew-nav-link]");

  function setOpen(open) {
    nav.setAttribute("data-mew-open", open ? "true" : "false");
    if (toggleBtn) toggleBtn.setAttribute("aria-expanded", open ? "true" : "false");
    if (drawer)   drawer.hidden   = !open;
    if (backdrop) backdrop.hidden = !open;
    document.documentElement.style.overflow = open ? "hidden" : "";
    document.body.style.overflow = open ? "hidden" : "";
  }

  if (toggleBtn) {
    toggleBtn.addEventListener("click", function () {
      setOpen(nav.getAttribute("data-mew-open") !== "true");
    });
  }

  if (closeBtn)  closeBtn.addEventListener("click",  () => setOpen(false));
  if (backdrop)  backdrop.addEventListener("click",  () => setOpen(false));
  navLinks.forEach((a) => a.addEventListener("click", () => setOpen(false)));

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") setOpen(false);
  });

  // تمييز الرابط الحالي
  const path = (window.location.pathname || "/").replace(/\/+$/, "") || "/";
  nav.querySelectorAll("a[data-mew-nav-link]").forEach(function (a) {
    const href = (a.getAttribute("href") || "/").replace(/[?#].*$/, "").replace(/\/+$/, "") || "/";
    if (href === path) a.setAttribute("aria-current", "page");
    else a.removeAttribute("aria-current");
  });

  // تأثير عند التمرير
  function handleScroll() {
    if (window.scrollY > 8) nav.classList.add("mew-nav--scrolled");
    else nav.classList.remove("mew-nav--scrolled");
  }
  handleScroll();
  window.addEventListener("scroll", handleScroll, { passive: true });

  setOpen(false);
})();
